import React from "react";
import { GOOGLE_TAG_CODE, SCRIPT_URL } from "../../common/constants";
import "../../App.css";
export default class SignupSuccess extends React.Component {
  componentDidMount() {
    let e, t;
    e = document.createElement("script");
    e.type = "text/javascript";
    e.id = "tracker-script";
    e.async = !0;
    e.defer = !0;
    e.src = SCRIPT_URL;
    t = document.getElementsByTagName("head")[0];
    // Adding as first child for head
    t.prepend(e);
    if (GOOGLE_TAG_CODE) {
      window["dataLayer"] = [];
      window["dataLayer"].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });
      var firstScriptTag = document.getElementsByTagName("script")[0];
      var scriptTag = document.createElement("script");
      var conversionScript = document.createElement("script");
      scriptTag.async = true;
      scriptTag.id = "gtm-script";
      conversionScript.id = "gtag-conversion-report";
      scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_CODE}`;
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
      conversionScript.innerText = `function gtag_report_conversion(url){var callback = function (){if(typeof(url) != 'undefined'){window.location = url;}};gtag('event', 'conversion',{'send_to': 'AW-1070812079/_A-TCNT_8okDEK-Xzf4D','event_callback': callback});return false;}`;
      let body = document.getElementsByTagName("body");
      body = body[0];
      body.insertAdjacentHTML(
        "afterbegin",
        "<noscript id='n-script'></noscript>"
      );
      let iFrame = document.createElement("iframe");
      iFrame.src = `https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_CODE}`;
      iFrame.style.cssText = "height=0;width=0;display:none;visibility:hidden";
      document.getElementById("n-script").appendChild(iFrame);
      t.appendChild(conversionScript);
      document.body.classList.add("bgColor");
    }
  }
  componentWillUnmount() {
    var element = document.getElementById("tracker-script");
    element.parentNode.removeChild(element);
    var element1 = document.getElementById("gtm-script");
    element1.parentNode.removeChild(element1);
    const element2 = document.getElementById("n-script");
    element2.parentNode.removeChild(element2);
    const element3 = document.getElementById("gtag-conversion-report");
    element3.parentNode.removeChild(element3);
    document.body.classList.remove("bgColor");
  }
  render() {
    return (
      <div className="signup-container">
        <div className="success-signup"></div>
        <div className="section-form">
          <div style={{ textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height:"100%"
         }}>
            <p
              style={{
                fontSize: 35,
                paddingTop: 65,
                marginBottom: 0,
              }}
            >
              Sign Up Successful
            </p>
            <p className="activationMsg">We've sent you an account activation link. Please check your Junk or Spam folders if not received in your Inbox.</p>
            <div
              onClick={() => window.open("https://cleanyourlists.com")}
              className="signupSuccess">
              <p style={{ marginBottom: 0 }}>Visit Website</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/SignupSuccess.js